import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  static values = { shiftIndex: Number, selectedDate: String, shiftsByDate: Object, userId: String, shiftCover: { type: Boolean, default: false } }
  static targets = [ 'userName', 'id', 'date', 'from', 'to', 'selectShiftButton', 'selectUserButton']

  updateUserShiftSelector(date_str) {
    const url = `/shifts/swaps/colleagues?date=${date_str}&shift_index=${this.shiftIndexValue}`
    this.renderTurboStreamFromUrl(url, this.frameId(), 'replace')
  }

  // triggered when current user has more shifts for date
  updateCurrentUserShiftSelector(date_str) {
    const url = `/shifts/swaps/my_shifts?date=${date_str}&shift_index=1`
    this.renderTurboStreamFromUrl(url, this.frameId(), 'replace')
  }

  // TODO: rewrite, pass mode from other controller
  modeTriple() {
    return this.element.closest('.swap-card-wrapper').getAttribute('data-shift-swap--wrapper-mode-value') == 'triple'
  }

  shiftSelectedCallback(event) {
    if(event.detail.shiftIndex == this.shiftIndexValue) {
      this.element.classList.add('selected') // highlight card

      this.idTarget.value = event.detail.shiftId
      this.fromTarget.textContent = event.detail.shiftRangeHumanized
      this.userNameTarget.textContent = event.detail.userName

      const date_input = this.element.querySelector(`input[name = 'shift${event.detail.shiftIndex}_date']`)

      date_input._flatpickr.close()
    }
  }

  shiftCoverToggle(event) {
    event.preventDefault()

    this.shiftCoverValue = event.target.checked
  }

  shiftCoverValueChanged() {
    if(this.shiftIndexValue != 2) {
      return
    }

    this.dispatch('shift-cover-changed', { detail: { value: this.shiftCoverValue } })

    if(this.shiftCoverValue) {
      this.selectShiftButtonTarget.classList.add('d-none')
      this.selectUserButtonTarget.classList.remove('d-none')
    } else {
      this.selectShiftButtonTarget.classList.remove('d-none')
      this.selectUserButtonTarget.classList.add('d-none')
    }
  }

  showCalendar(event) {
    event.preventDefault()

    const context = this
    const shiftIndex = event.params.shiftIndex

    let config = {
      ariaDateFormat: 'Y-m-d',
      dateFormat: 'Y-m-d',
      disableMobile: true,
      locale: {
        firstDayOfWeek: 1
      },
      clickOpens: false, // prevent open calendar on input click, which is hidden anyway here
      positionElement: event.target,
      minDate: 'today',
      onOpen: function(_selectedDates, _dateStr, instance) {
        context.setDaysDutyColors(instance) //instance.currentYear, instance.currentMonth + 1)

        const turbo_frame = document.createElement('turbo-frame')
        turbo_frame.setAttribute('id', context.frameId(shiftIndex))
        instance.calendarContainer.appendChild(turbo_frame)

        instance.calendarContainer.classList.add('with-shift-swap-shift-selector') // used to apply css customizations
      },
      onMonthChange: function(_selectedDates, _dateStr, instance) {
        context.setDaysDutyColors(instance)
      },
      onChange: function(_selectedDates, dateStr, instance) {
        const more_shifts_for_date = Array.isArray(context.shiftsByDateValue[dateStr])

        if(context.userIdValue && !more_shifts_for_date) {
          const shift = context.shiftsByDateValue[dateStr]

          // update fields for current user card
          const range_humanized = shift['range_humanized']
          const id = shift['id']
          context.fromTarget.textContent = range_humanized
          context.idTarget.value = id

          context.element.classList.add('selected') // highlight card

          instance.close()
        } else {
          // when other user shift selected or current user has more than one shift for selected day
          if(more_shifts_for_date && shiftIndex == 1) {
            context.updateCurrentUserShiftSelector(dateStr)
          } else {
            context.updateUserShiftSelector(dateStr)
          }
        }
      }
    }

    if(window.innerWidth < 768) {
      config.position = 'above auto'
    }

    if(this.hasShifts()) {
      const dates = Object.keys(this.shiftsByDateValue)
      config.enable = dates.map(d => new Date(d))
    } else if (this.userIdValue) {
      // user set but no shifts
      config.enable = []
    }

    // calendar is closed/destroyed manually depends on scenario
    config.closeOnSelect = false

    const fp = flatpickr(this.dateTarget, config)
    fp.open()
  }

  setDaysDutyColors(instance) {
    if(!this.hasShifts()) {
      return
    }
    const elements = instance.calendarContainer.querySelectorAll('.dayContainer .flatpickr-day:not(.flatpickr-disabled)')

    elements.forEach((el) => {
      const date_str = el.getAttribute('aria-label')
      const shift = this.shiftsByDateValue[date_str]
      const css_class = Array.isArray(shift) ? shift[0]['css_selector'] : shift['css_selector']
      if(css_class) {
        el.classList.add(css_class)
      }
    })
  }

  frameId(index = null) {
    if(!index) {
      index = this.shiftIndexValue
    }
    return `shift-selector-${index}`
  }

  // TODO: refactor, used in a few places
  renderTurboStreamFromUrl(url, target, action = 'replace') {
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(r => r.text())
    .then(html => {
      html = `<turbo-stream action="${action}" target="${target}"><template>${html}</template></turbo-stream>`
      Turbo.renderStreamMessage(html)
    })
  }

  hasShifts() {
    return Object.keys(this.shiftsByDateValue).length > 0
  }
}
